import { useState, type FormEvent } from 'react'
import { Link } from '@tanstack/react-router'
import { Alert, AuthCard, Button, Field } from '../components/ui'
import { useForgotPassword } from '../lib/session'

// Meme reponse que l'adresse ait un compte ou non : pas d'enumeration des inscrits.
export default function ForgotPasswordPage() {
  const forgot = useForgotPassword()
  const [email, setEmail] = useState('')

  const onSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    forgot.mutate(email)
  }

  return (
    <AuthCard
      title="Mot de passe oublie"
      subtitle="Saisissez votre adresse : vous recevrez un lien pour choisir un nouveau mot de passe."
    >
      {forgot.isSuccess ? (
        <Alert tone="success">
          Si un compte existe pour {email}, un lien de reinitialisation vient de lui etre envoye.
        </Alert>
      ) : (
        <form onSubmit={onSubmit} className="space-y-4">
          <Field
            label="Adresse e-mail"
            type="email"
            name="email"
            autoComplete="username"
            required
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />

          {forgot.isError && <Alert>{forgot.error.message}</Alert>}

          <Button type="submit" disabled={forgot.isPending}>
            {forgot.isPending ? 'Envoi...' : 'Envoyer le lien'}
          </Button>
        </form>
      )}

      <p className="mt-6 text-center text-sm">
        <Link to="/login" className="font-medium underline underline-offset-4">
          Retour a la connexion
        </Link>
      </p>
    </AuthCard>
  )
}
